import { render, staticRenderFns } from "./StartCollegeSessionModal.vue?vue&type=template&id=1754b1d9&scoped=true&"
import script from "./StartCollegeSessionModal.vue?vue&type=script&lang=js&"
export * from "./StartCollegeSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./StartCollegeSessionModal.vue?vue&type=style&index=0&id=1754b1d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754b1d9",
  null
  
)

export default component.exports